import React, { useEffect, useState } from "react";
import { Button, Col, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { Select, MenuItem } from "@mui/material"

import { Common, MarkingColors } from "../../../helper";
import { isEmptyArray, isNullOrEmpty } from "../../../util";
import { CommonModal } from "../../Shared";

import "../../../assets/stlyes/RadioMarking.css";

import Comm from "../../../assets/images/WhiteComment.png";
import GreyComment from "../../../assets/images/GreyComment.png";

const RadioMarking = (props) => {
  const { index, cards, _markings, year, finalUpdatedData, _description, pupilMarkss } = props;
  let totalCards = cards && cards.filter((card) => card.year <= parseInt(year))
  const [belowComment, setbelowComment] = useState("");
  const [workingComment, setworkingComment] = useState("");
  const [expectedComment, setexpectedComment] = useState("");
  const [greaterComment, setgreaterComment] = useState("");
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [selectedYearOptions, setSelectedYearOptions] = useState();
  const handleClose = () => setShow(false);
  const [grade, setGrade] = useState();
  const [showModal, setShowModal] = useState(false);
  const handleShowModal = () => setShowModal(false);

  const MarkBelow = (e) => {
    e.target.value === `${year}B` ?
      finalUpdatedData.pupilId[index].marks = [`${year}B`] : finalUpdatedData.pupilId[index].marks = [`${year}B`, e.target.value]
    finalUpdatedData.pupilId[index].comment = belowComment;
    pupilMarkss(finalUpdatedData)
  }
  const markWorking = () => {
    finalUpdatedData.pupilId[index].comment = workingComment;
    finalUpdatedData.pupilId[index].marks[0] !== `${year}W` ? finalUpdatedData.pupilId[index].marks = [`${year}W`] : finalUpdatedData.pupilId[index].marks = ["0"]
    pupilMarkss(finalUpdatedData)
  }
  const markExpected = () => {
    finalUpdatedData.pupilId[index].comment = expectedComment;
    finalUpdatedData.pupilId[index].marks[0] !== `${year}E` ? finalUpdatedData.pupilId[index].marks = [`${year}E`] : finalUpdatedData.pupilId[index].marks = ["0"]
    pupilMarkss(finalUpdatedData)
  }
  const markGreater = () => {
    finalUpdatedData.pupilId[index].comment = greaterComment;
    finalUpdatedData.pupilId[index].marks[0] !== `${year}G` ? finalUpdatedData.pupilId[index].marks = [`${year}G`] : finalUpdatedData.pupilId[index].marks = ["0"]
    pupilMarkss(finalUpdatedData)
  }
  const markAbsent = () => {
    finalUpdatedData.pupilId[index].marks[0] !== `${year}A` ? finalUpdatedData.pupilId[index].marks = [`${year}A`] : finalUpdatedData.pupilId[index].marks = ["0"]
    pupilMarkss(finalUpdatedData)
  }

  const clearMark = () => {
    if (finalUpdatedData && finalUpdatedData.pupilId && finalUpdatedData.pupilId[index]) { finalUpdatedData.pupilId[index].marks = ["0"]; pupilMarkss(finalUpdatedData); }
  }

  const handleCLearMark = () => {
    clearMark()
    setShowModal(false)
  }

  const closeModalHandler = () => {
    handleClose();
  };

  const handleCommentClick = () => {
    let data = finalUpdatedData.pupilId[index].marks[0][1] === "B"
      ? "B"
      : finalUpdatedData.pupilId[index].marks[0][1] === "W"
        ? "W"
        : finalUpdatedData.pupilId[index].marks[0][1] === "G"
          ? "G"
          : finalUpdatedData.pupilId[index].marks[0][1] === "E"
            ? "E"
            : "A";
    setGrade(data);
    handleShow();
  }

  const data = []
  const getMarkings = () => {
    if (totalCards && totalCards.length === 1) {
      data.push(...data, totalCards[0].year + "B");
      setSelectedYearOptions(data)
    } else {
      let Suffix = ["W", "E", "G"]
      totalCards && totalCards.map((item, index) => {
        if (totalCards[index].year < parseInt(year)) {
          if (index === 0) {
            data.push(totalCards[index].year + "B")
          }
          else if (parseInt(year) === 1) {
            data.push(totalCards[index].year + "B")
          }
          for (let i = 0; i < Suffix.length; i++) {
            data.push(item.year + Suffix[i]);
          }
        }
      })
      data.reverse();
      setSelectedYearOptions(data);
    }
    setValues();
  }

  const setValues = () => {
    if (!isEmptyArray(finalUpdatedData.pupilId[index]?.marks)) {
      if (finalUpdatedData.pupilId[index]?.marks.length === 1 && finalUpdatedData.pupilId[index]?.marks[0][1] === "B") {
        setbelowComment(finalUpdatedData.pupilId[index].comment)
      }
      else if (finalUpdatedData.pupilId[index].marks.length === 1) {
        if (finalUpdatedData.pupilId[index].marks[0][1] === "G") {
          setgreaterComment(finalUpdatedData.pupilId[index].comment)
        }
        else if (finalUpdatedData.pupilId[index].marks[0][1] === "E") {
          setexpectedComment(finalUpdatedData.pupilId[index].comment)
        }
        else if (finalUpdatedData.pupilId[index].marks[0][1] === "W") {
          setworkingComment(finalUpdatedData.pupilId[index].comment)
        }
      }
      else {
        setbelowComment(finalUpdatedData.pupilId[index].comment);
      }
    }
  }

  useEffect(() => {
    getMarkings();
  }, [cards, finalUpdatedData])

  return (
    <div className="radio-marking">
      <Col xs={12} className="marking-column">
        <div className="below-column">
          <Select className="below-mark" value={finalUpdatedData.pupilId[index].marks[0][1] == "B" ? (finalUpdatedData.pupilId[index].marks.length > 1 ? finalUpdatedData.pupilId[index].marks[1] : finalUpdatedData.pupilId[index].marks[0] == "0" ? "" : finalUpdatedData.pupilId[index].marks[0]) : ""} style={{ background: (((finalUpdatedData.pupilId[index].marks[0] == "0" ? "" : (finalUpdatedData.pupilId[index].marks.length > 1 ? finalUpdatedData.pupilId[index].marks[1][1] : finalUpdatedData.pupilId[index].marks[0][1])) == "B") || (finalUpdatedData.pupilId[index].marks.length > 1 ? ((finalUpdatedData.pupilId[index].marks[1] && finalUpdatedData.pupilId[index].marks[1][0]) < year ? true : false) : false)) ? MarkingColors.Below : MarkingColors.White, color: !(((finalUpdatedData.pupilId[index].marks[0] == "0" ? "" : (finalUpdatedData.pupilId[index].marks.length > 1 ? finalUpdatedData.pupilId[index].marks[1][1] : finalUpdatedData.pupilId[index].marks[0][1])) == "B") || (finalUpdatedData.pupilId[index].marks.length > 1 ? ((finalUpdatedData.pupilId[index].marks[1] && finalUpdatedData.pupilId[index].marks[1][0]) < year ? true : false) : false)) ? MarkingColors.Below : MarkingColors.White }} onChange={(e) => MarkBelow(e)} inputProps={{ IconComponent: () => null }}>
            {selectedYearOptions && selectedYearOptions.map((item) => (<MenuItem key={item} value={item} className="dropDownClassMarkOption">{item}</MenuItem>))}
          </Select>
          {finalUpdatedData.pupilId[index].marks[0][1] == "B" && <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{belowComment}</Tooltip>}>
            <span className="d-inline-block">
              <Button className="below-comment" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "B" ? MarkingColors.Below : MarkingColors.White }} onClick={() => handleCommentClick()}>{isNullOrEmpty(belowComment) ? <img src={Comm} alt="" /> : <img src={GreyComment} alt="" />}</Button>
            </span>
          </OverlayTrigger>}
        </div>
        <div className="workingtowards-column">
          <Button className="workingtowards-mark" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "W" ? MarkingColors.Emerging : MarkingColors.White }} onClick={markWorking}></Button>
          {finalUpdatedData.pupilId[index].marks[0][1] == "W" && <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{workingComment}</Tooltip>}>
            <span className="d-inline-block">
              <Button className="workingtowards-comment" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "W" ? MarkingColors.Emerging : MarkingColors.White }} onClick={() => handleCommentClick()}>{isNullOrEmpty(workingComment) ? <img src={Comm} alt="" /> : <img src={GreyComment} alt="" />}</Button>
            </span>
          </OverlayTrigger>}
        </div>
        <div className="expected-column">
          <Button className="expected-mark" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "E" ? MarkingColors.Expected : MarkingColors.White }} onClick={markExpected}></Button>
          {finalUpdatedData.pupilId[index].marks[0][1] == "E" && <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{expectedComment}</Tooltip>}>
            <span className="d-inline-block">
              <Button className="expected-comment" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "E" ? MarkingColors.Expected : MarkingColors.White }} onClick={() => handleCommentClick()}>{isNullOrEmpty(expectedComment) ? <img src={Comm} alt="" /> : <img src={GreyComment} alt="" />}</Button>
            </span>
          </OverlayTrigger>}
        </div>
        <div className="greaterdepth-column">
          <Button className="greaterdepth-mark" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "G" ? MarkingColors.GreaterDepth : MarkingColors.White }} onClick={markGreater}></Button>
          {finalUpdatedData.pupilId[index].marks[0][1] == "G" && <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">{greaterComment}</Tooltip>}>
            <span className="d-inline-block">
              <Button className="greaterdepth-comment" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "G" ? MarkingColors.GreaterDepth : MarkingColors.White }} onClick={() => handleCommentClick()}>{isNullOrEmpty(greaterComment) ? <img src={Comm} alt="" /> : <img src={GreyComment} alt="" />}</Button>
            </span>
          </OverlayTrigger>}
        </div>
        <div className="absent-column">
          <Button className="absent-mark" style={{ background: finalUpdatedData.pupilId[index].marks[0][1] == "A" ? MarkingColors.Absent : MarkingColors.White }} onClick={markAbsent}></Button>
        </div>
        <div >
          <button className="clear-mark-button" onClick={() => setShowModal(true)}>{Common.X}</button>
        </div>
      </Col>
      {show && <CommonModal show={show} close={closeModalHandler} _description={_description} comment={finalUpdatedData.pupilId[index].comment} _markings={_markings} finalUpdatedData={finalUpdatedData} pupilMarkss={pupilMarkss} index={index} grade={grade && grade} setbelowComment={setbelowComment} setworkingComment={setworkingComment} setexpectedComment={setexpectedComment} setgreaterComment={setgreaterComment} />}
      <Modal show={showModal} onHide={handleShowModal} className="comment-modal">
        <Modal.Header closeButton className="comment-modal-header">
          <Modal.Title>{ }</Modal.Title>
        </Modal.Header>
        <Modal.Body className="comment-modal-body">{"This will remove the most recent mark recorded. Are you sure?"}</Modal.Body>
        <Modal.Footer className="comment-modal-footer justify-content-center">
          <Button variant="danger" onClick={() => setShowModal(false)} className="comment-modal-cancelbtn">
            {Common.No}
          </Button>
          <Button variant="success" onClick={handleCLearMark} className="comment-modal-savebtn">
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  )
}

export { RadioMarking }